import { useCallback } from 'react';

import { useConfirmationModal } from '@/Client/State';

/** Confirms the deliberate replacement of an active audience-doc share link. */
export const useAudienceDocShareLinkReplacementConfirmation = () => {
  const confirm = useConfirmationModal();

  return useCallback(
    (onConfirm: () => unknown | Promise<unknown>) =>
      confirm({
        title: 'Replace active link?',
        message:
          'Creating a new link will immediately invalidate the link you previously copied for this audience doc. People using the older link will no longer be able to open it.',
        confirmLabel: 'Create new link',
        cancelLabel: 'Keep current link',
        onConfirm,
      }),
    [confirm],
  );
};
